import { render, staticRenderFns } from "./MaterialCreateEdit.vue?vue&type=template&id=54de7214&scoped=true"
import script from "./MaterialCreateEdit.vue?vue&type=script&lang=js"
export * from "./MaterialCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./MaterialCreateEdit.vue?vue&type=style&index=0&id=54de7214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de7214",
  null
  
)

export default component.exports